import React from "react";
import { Route, Routes, Router, HashRouter, Navigate, BrowserRouter } from "react-router-dom";
import Home from "../pages/home/HomeComponent";
import Splash from "../pages/splash/Splash";
import Education from "../pages/education/EducationComponent";
import Experience from "../pages/experience/Experience";
import Contact from "../pages/contact/ContactComponent";
import Projects from "../pages/projects/Projects";
import { settings } from "../portfolio.js";
import Sidebar from "../components/sidebar/Sidebar.js";

export default function Main(propss) {
  if (settings.isSplash) {
    return (
      <div>
        {/* <HashRouter basename="/"> */}
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <Splash theme={propss.theme} setTheme={propss.setTheme} />
              }
            />
            <Route
              path="/home"
              element={<> <Sidebar /> <Home theme={propss.theme} setTheme={propss.setTheme} /> </>}
            />
            <Route
              path="/experience"
              element={
                <><Sidebar /> <Experience theme={propss.theme} setTheme={propss.setTheme} /> </>
              }
            />
            <Route
              path="/education"
              element={
                <><Sidebar /> <Education theme={propss.theme} setTheme={propss.setTheme} /></>
              }
            />
            <Route
              path="/contact"
              element={
                <> <Sidebar /> <Contact theme={propss.theme} setTheme={propss.setTheme} /></>
              }
            />
            <Route
              path="/splash"
              element={
                <Splash theme={propss.theme} setTheme={propss.setTheme} />
              }
            />
            <Route
              path="/projects"
              element={
                <><Sidebar /> <Projects theme={propss.theme} setTheme={propss.setTheme} /></>
              }
            />
            <Route path="*" element={<Navigate to={"/"} />} />
          </Routes>
          </BrowserRouter>
        {/* </HashRouter> */}
      </div>
    );
  } else {
    return (
      <div>
        <HashRouter basename="/">
          <Routes>
            <Route
              path="/"
              element={<Home theme={propss.theme} setTheme={propss.setTheme} />}
            />
            <Route
              path="/home"
              element={<Home theme={propss.theme} setTheme={propss.setTheme} />}
            />
            <Route
              path="/experience"
              element={
                <Experience theme={propss.theme} setTheme={propss.setTheme} />
              }
            />
            <Route
              path="/education"
              element={
                <Education theme={propss.theme} setTheme={propss.setTheme} />
              }
            />
            <Route
              path="/contact"
              element={
                <Contact theme={propss.theme} setTheme={propss.setTheme} />
              }
            />
            <Route
              path="/projects"
              element={
                <Projects theme={propss.theme} setTheme={propss.setTheme} />
              }
            />
            <Route path="*" element={<Navigate to={"/"} />} />
          </Routes>
        </HashRouter>
      </div>
    );
  }
}
